import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {ImageUploader, VideoUploader} from '../uploaders';
import './booth-editor.css';

/** @class VideoContentData
 * A component to enable editing properties
 * specific to VideoContents.
 */
export default class VideoContentData extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    this.state = props.content;
    this.handleChange = this.handleChange.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleVideoUpload = this.handleVideoUpload.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleImageUpload
    * Applies user changes to the state
    * @param {url} url - the URL of the image
    */
  handleImageUpload(url) {
    this.setState({thumbnail: url}, () => {
      this.handleBlur();
    });
  }
  /** @function handleVideoUpload
    * Applies user changes to the state
    * @param {url} url - the URL of the image
    */
  handleVideoUpload(url) {
    this.setState({video: url}, () => {
      this.handleBlur();
    });
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
  /** @function render
    * Renders the component
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Video Content</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text"
            name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="columns">Columns</label><br/>
          <input type="number"
            name="columns"
            value={this.state.columns}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            max="4"
            min="1"
            step="1"
            />
        </div>
        <div className="input-group">
          <label htmlFor="published">
            <input type="checkbox"
              name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />&nbsp;
            Published
          </label>
        </div>
        <div className="input-group">
          <ImageUploader
            name="Thumbnail"
            value={this.state.thumbnail}
            dataURL={this.props.dataURL + '/thumbnail'}
            onUpload={this.handleImageUpload}
            />
        </div>
        <div className="input-group">
          <VideoUploader
            name="Video"
            value={this.state.video}
            dataURL={this.props.dataURL + '/video'}
            onUpload={this.handleVideoUpload}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/video-content-data.js